import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import { clinicInfo } from '../mockData';
import { openWhatsApp } from '@/lib/whatsapp';

const Footer = () => {
  const handleWhatsAppClick = () => {
    openWhatsApp({
      section: 'footer',
      message: 'Olá! Vim pelo site e quero tirar umas dúvidas.',
    });
  };

  return (
    <footer id="contato" className="border-t border-white/10 bg-brand-ink py-16 text-white">
      <div className="container mx-auto px-4">
        <div className="mb-12 grid gap-10 md:grid-cols-3">
          <div>
            <div className="mb-5 inline-block rounded-xl bg-white p-2 shadow-md ring-1 ring-white/20">
              <img
                src="/images/logo.jpeg"
                alt="Clínica Líder Odontologia"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-white/65">
              Há mais de {clinicInfo.experience} cuidando de sorrisos em Paranaguá. Aparelho, implante e
              tratamentos para toda a família — com parcelamento facilitado.
            </p>
            <div className="mt-4 flex items-center gap-2">
              <span className="text-brand-gold">★★★★★</span>
              <span className="text-sm text-white/70">{clinicInfo.rating} no Google</span>
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold text-white">Contato</h4>
            <div className="mt-4 space-y-4">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="flex w-full items-start gap-3 text-left text-white/80 transition hover:text-white"
              >
                <Phone className="mt-0.5 h-5 w-5 shrink-0 text-brand-gold" strokeWidth={1.75} />
                <div>
                  <div className="text-sm font-semibold text-white">WhatsApp</div>
                  <div className="text-sm text-white/60">{clinicInfo.phone}</div>
                </div>
              </button>

              <div className="flex items-start gap-3 text-white/80">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-brand-gold" strokeWidth={1.75} />
                <div>
                  <div className="text-sm font-semibold text-white">Endereço</div>
                  <div className="text-sm text-white/60">{clinicInfo.address}</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold text-white">Horário</h4>
            <div className="mt-4 space-y-4">
              <div className="flex items-start gap-3">
                <Clock className="mt-0.5 h-5 w-5 shrink-0 text-brand-gold" strokeWidth={1.75} />
                <div>
                  <div className="text-sm font-semibold text-white">Segunda a sexta</div>
                  <div className="text-sm text-white/60">09:00 – 19:00</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="mt-0.5 h-5 w-5 shrink-0 text-brand-gold" strokeWidth={1.75} />
                <div>
                  <div className="text-sm font-semibold text-white">Sábado e domingo</div>
                  <div className="text-sm text-white/60">Fechado</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10 text-center">
          <p className="font-display text-xl text-brand-gold md:text-2xl">
            Ortodontia Líder — cuidando do seu sorriso com carinho e honestidade.
          </p>
          <p className="mt-3 text-sm text-white/45">
            © {new Date().getFullYear()} Ortodontia Líder. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
